import moment from 'moment'

export const dateTimeDiff = (start: Date | string | undefined, end: Date | string | undefined) => {
  try {
    const startDate = moment(start)
    const endDate = moment(end)

    const days = endDate.diff(startDate, 'days')
    const hours = endDate.diff(startDate, 'hours')

    return {
      days,
      hours
    }
  } catch (error) {
    return { days: 0, hours: 0 }
  }
}

export const getPriceMatrix = (days: number, hours: number) => {
  if (days == 0 && hours > 0) {
    return PRICE_MATRIX.HOURLY
  }

  if (days % 7 == 0) {
    return PRICE_MATRIX.WEEKLY
  }

  if (days > 0) {
    return PRICE_MATRIX.DAILY
  }
  return null
}

export const PRICE_MATRIX = {
  HOURLY: { key: 'hourlyRate', display: 'hour' },
  WEEKLY: { key: 'weeklyRate', display: 'week' },
  DAILY: { key: 'dailyRate', display: 'daily' }
}

export const STELLANTIS_CUSTOMER_POSTMESSAGE_TEMPLATE = {
  message: '{ "eventAction": "form", "eventName": "start", "type": "CustomTagEvent", "attributes": { "formDescription": "lead", "formType": "test drive", "displayType": "iFrame", "displayFormat": "inpage", "thirdPartyToolProvider": "extended-test-drive|TSD" } }',
  target: '*'
}

export const STELLANTIS_SUBMIT_POSTMESSAGE_TEMPLATE = {
  message: { "eventAction": "form", "eventName": "submit", "type": "CustomTagEvent", "attributes": { "formDescription": "lead", "formType": "test drive", "displayType": "iFrame", "displayFormat" :"inpage", "thirdPartyToolProvider": "extended-test-drive|TSD", "leadId": undefined } },
  target: '*'
}

export function stellantisFormSubmitMessageWithParams(leadId: string | undefined) {
    let jsonSubmitMsg =  STELLANTIS_SUBMIT_POSTMESSAGE_TEMPLATE.message
    modifyDeepObjectProperty(jsonSubmitMsg, ["attributes", "leadId"], leadId);
    return jsonSubmitMsg
}

export function modifyDeepObjectProperty(obj: any, path: string[], newValue: any) {
  if (path.length === 0) {
    return newValue;
  }

  const key:string = path.shift() ?? "";
  if (obj.hasOwnProperty(key)) {
    obj[key] = modifyDeepObjectProperty(obj[key], path, newValue);
  }

  return obj;
}
